import { Component, h, Host, Prop, State } from '@stencil/core';
import { ListProduct } from '~model/product';
import { get, normalizeUrl } from '~service/shop-service';

@Component({
  tag: 'uvex-product-stream-slider',
  styleUrl: 'product-stream-slider.scss',
})
export class ProductStreamSlider {
  @Prop() stream: string;
  @State() products: ListProduct[] = [];
  @State() loading = true;

  async componentDidLoad() {
    try {
      const apiUrl = new URL(normalizeUrl(this.stream));
      const { data } = await get(apiUrl.toString());
      this.products = data.attributes.articles || [];
    } catch (e) {}
    this.loading = false;
  }

  render() {
    if (this.loading) {
      return (
        <Host class="product-slider-wrap loading">
          <slot />
          <uvex-spinner inline={true} active={true} />
        </Host>
      );
    }

    if (this.products.length === 0) {
      return (
        <Host hidden={true}>
          <slot />
        </Host>
      );
    }

    return (
      <Host class="product-slider-wrap">
        <slot />
        <uvex-slider-product class="carousel-shopware-style">
          {this.products.map(product => (
            <div class="carousel-slide">
              <uvex-product product={product} />
            </div>
          ))}
        </uvex-slider-product>
      </Host>
    );
  }
}
